import { DashboardLayout } from '@/components/layout/DashboardLayout';
import MultiCompanyAuditorConsole from '@/components/compliance/MultiCompanyAuditorConsole';
import RegulatorAccessManager from '@/components/compliance/RegulatorAccessManager';
import RegulatorInviteManager from '@/components/compliance/RegulatorInviteManager';

export default function MultiCompanyAudit() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">Multi-Company Audit Console</h1>
          <p className="text-muted-foreground mt-1">
            Comprehensive audit overview across all accessible companies
          </p>
        </div>
        <RegulatorAccessManager />
        <RegulatorInviteManager />
        <MultiCompanyAuditorConsole />
      </div>
    </DashboardLayout>
  );
}
